import React, { FunctionComponent } from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner: FunctionComponent = () => (
    <Spinner animation="border" variant="primary" data-cy="loading" data-testid="loading" />
);

export default LoadingSpinner;
